import { ohFail, OhHellRulesMessage, ohSucceed } from '../state/state.js';
export function kickPlayer(state, kickData) {
    if (!state.players || state.players.length < 2) {
        return ohFail(OhHellRulesMessage.CantKickLastPlayer);
    }
    const exitingUserId = kickData.kickedPlayerId;
    const players = buildPlayersWithExitedPlayer(state, exitingUserId, kickData.kickReason);
    const kickedState = {
        ...state,
        players,
    };
    return ohSucceed(kickedState, []);
}
const buildPlayersWithExitedPlayer = (state, exitingPlayerId, kickReason) => {
    const players = [...state.players];
    const exitingPlayerIndex = players.findIndex((player) => player.userId === exitingPlayerId);
    if (exitingPlayerIndex !== -1) {
        const exitedPlayer = {
            ...players[exitingPlayerIndex],
            didExit: true,
            kickReason: kickReason || null,
        };
        players.splice(exitingPlayerIndex, 1, exitedPlayer);
    }
    return players;
};
//# sourceMappingURL=kickPlayer.js.map